module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-sailor.407a2b62.jpg";